const flag = (key) => String(process.env[key]).toLowerCase() === 'true';

export const APP_MODULES_CONFIG = {
  modeDemo: flag('REACT_APP_MODE_DEMO'),
  testPage: flag('REACT_APP_DEMO_SHOW_TEST_PAGE')
};
